import { render, staticRenderFns } from "./UserSettingsDialog.vue?vue&type=template&id=29922c80&scoped=true"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=js"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsDialog.vue?vue&type=style&index=0&id=29922c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29922c80",
  null
  
)

export default component.exports